import { GroupType } from '@bp/bp-graphql-types';
import { graphql } from 'client/gql';
import { CourseEditorsModal } from 'components/Courses/modals/CourseEditorsModal';
import { CourseViewersModal } from 'components/Courses/modals/CourseViewersModal';
import { CooperationCoursesTable } from 'components/Courses/tables/CooperationCoursesTable';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'urql';
import { BpSubpage } from '../../../components/BpSubpage/BpSubpage';
import { useAuthClaims } from '../../../hooks/useAuthClaims';
import { updateClaims } from '../../../utils/authStore';

const SettingsCollaborationCoursesSubpageQueryDocument = graphql(`
  query SettingsCollaborationCoursesSubpageData($courseWhere: GroupWhere!, $organizationUuid: ID!, $courseUuid: ID!) {
    ...UseCoursesTableFields
    ...CourseEditorsFormFields
    ...CourseViewersFormFields
  }
`);

export const SettingsCollaborationCoursesSubpage = () => {
  const { pimAuthClaims } = useAuthClaims();
  const organizationUuid = pimAuthClaims.getOrganizationUuid();
  const navigate = useNavigate();

  const [claimsTrigger, setClaimsTrigger] = useState<boolean>(false);
  const [editorsModalOpen, setEditorsModalOpen] = useState<boolean>(false);
  const [viewersModalOpen, setViewersModalOpen] = useState<boolean>(false);
  const [courseUuid, setCourseUuid] = useState<string | null>(null);

  const [{ data }] = useQuery({
    query: SettingsCollaborationCoursesSubpageQueryDocument,
    variables: {
      organizationUuid: organizationUuid,
      schoolYearUuid: '',
      courseUuid: courseUuid ?? '',
      courseWhere: {
        type: GroupType.Course,
        isCommunity: true,
        AND: [
          {
            organization_NOT: { uuid: organizationUuid },
          },
          {
            admins_SOME: { organization: { uuid: organizationUuid } },
          },
        ],
      },
    },
  });

  const permissions = usePermissionChecker();

  function handleNavigate(uuid: string) {
    navigate('/courses/' + uuid);
  }

  function handleEditorsEdit(uuid: string) {
    setEditorsModalOpen(true);
    setCourseUuid(uuid);
  }

  function handleViewersEdit(uuid: string) {
    setViewersModalOpen(true);
    setCourseUuid(uuid);
  }

  async function handleClose() {
    setCourseUuid(null);
    setEditorsModalOpen(false);
    setViewersModalOpen(false);
    await updateClaims(() => setClaimsTrigger(!claimsTrigger));
  }

  return (
    <BpSubpage isForbidden={!permissions?.canUpdateCollaborationCourses() || !permissions?.canCreateCourse()}>
      <CooperationCoursesTable
        query={data}
        permissions={permissions}
        onNavigate={handleNavigate}
        onEditorsEdit={handleEditorsEdit}
        onViewersEdit={handleViewersEdit}
      />

      {courseUuid && (
        <CourseEditorsModal
          isOpen={editorsModalOpen}
          courseUuid={courseUuid}
          schoolYearUuid={''}
          onClose={handleClose}
          query={data}
        />
      )}

      {courseUuid && (
        <CourseViewersModal
          isOpen={viewersModalOpen}
          courseUuid={courseUuid}
          schoolYearUuid={''}
          onClose={handleClose}
          query={data}
        />
      )}
    </BpSubpage>
  );
};
